{
  "title": "Clairvoyance",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level divination",
  "level": 3,
  "castingTime": "10 minutes",
  "range": "1 mile",
  "components": "V, S, M (a focus worth at least 100 gp, either a jeweled horn for hearing or a glass eye for seeing)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You create an invisible sensor within range in a location familiar to you (a place you have visited or seen before) or in an obvious location that is unfamiliar to you (such as behind a door, around a corner, or in a grove of trees). The sensor remains in place for the duration, and it can’t be attacked or otherwise interacted with.",
    "When you cast the spell, you choose seeing or hearing. You can use the chosen sense through the sensor as if you were in its space. As your action, you can switch between seeing and hearing. A creature that can see the sensor (such as a creature benefitting from see invisibility or truesight) sees a luminous, intangible orb about the size of your fist."
  ],
  "spellLists": ["bard", "cleric", "sorcerer", "wizard"]
}
